import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import cities from "./cities";

const KarnatakaSEO = () => {
  const { city } = useParams();

  const cityData = cities.find((c) => c.slug === city);

  if (!cityData) return null;

  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>{cityData.title}</title>

      <meta
        name="description"
        content={cityData.description}
      />

      <meta
        name="keywords"
        content={`sex toys in ${cityData.city}, buy sex toys ${cityData.city}, adult toys ${cityData.city}, sex toys Karnataka, couples toys ${cityData.city}`}
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href={`https://lushdesire.in/sex-toys-delivery/karnataka/${cityData.slug}`}
      />

      {/* 🟢 OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={`Sex Toys in ${cityData.city} | 100% Discreet Delivery`}
      />
      <meta
        property="og:description"
        content={`Buy premium sex toys in ${cityData.city}, Karnataka with fast & private delivery. Trusted adult store.`}
      />
      <meta
        property="og:url"
        content={`https://lushdesire.in/sex-toys-delivery/karnataka/${cityData.slug}`}
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-karnataka.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content={`Sex Toys Delivery in ${cityData.city}`}
      />
      <meta
        name="twitter:description"
        content={`Discreet sex toys delivery in ${cityData.city}, Karnataka. Buy online for men, women & couples.`}
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-KA" />
      <meta name="geo.placename" content={cityData.city} />
      <meta name="geo.position" content="15.3173;75.7139" />
      <meta name="ICBM" content="15.3173, 75.7139" />

      {/* 🟢 SCHEMA – LOCAL BUSINESS */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire ${cityData.city}",
          "url": "https://lushdesire.in/sex-toys-delivery/karnataka/${cityData.slug}",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in ${cityData.city}, Karnataka with discreet packaging and fast delivery.",
          "areaServed": {
            "@type": "City",
            "name": "${cityData.city}"
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "${cityData.city}",
            "addressRegion": "Karnataka",
            "addressCountry": "IN"
          }
        }
        `}
      </script>
    </Helmet>
  );
};

export default KarnatakaSEO;
